<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="addEditGlobalWebsiteModal"
        persistent
        max-width="500px"
      >
        <v-card>
          <form @submit.prevent="submitForm()">
            <v-card-title class="pb-0">
              <v-flex
                xs11
                sm10
                md10
              >
                <span class="headline">
                  {{ isUpdate ? $t('mobileApp.updateGlobalWebsiteTitle') : $t('mobileApp.addNewGlobalWebsiteButton') }}
                </span>
              </v-flex>
              <v-flex
                xs1
                sm2
                md2
              >
                <v-btn
                  flat
                  @click="closeDialog()"
                  class="close"
                >
                  <span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-layout wrap>
                <input
                  type="file"
                  ref="globalWebsiteLogoRef"
                  style="position: absolute; visibility: hidden; top: -9999999;"
                  accept="image/*"
                  @input="imageSelected()"
                >

                <v-flex xs12>
                  <div
                    class="image-upload"
                    style="width: 100%; height: 200px;"
                    :style="
                      form.logoUrl
                        ? `background-image: url(${form.logoUrl})`
                        : ''
                    "
                    @click="chooseImage()"
                  >
                    <div
                      :style="form.logoUrl ? 'display: none' : ''"
                      class="image-upload-icon text-center"
                    >
                      <i class="fa fa-cloud"></i>
                      <span class="d-block text-caption text--secondary">
                        {{ $t('mobileApp.uploadLogo') }}
                      </span>
                    </div>
                  </div>
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                    v-model.number="form.url"
                    :label="$t('columns.url')"
                    :error-messages="errors.collect('URL')"
                    v-validate="'required'"
                    data-vv-name="URL"
                  />
                </v-flex>

                <v-flex xs12>
                  <v-select
                    :items="warehouses"
                    item-value="value"
                    v-model="form.warehouse_id_fk"
                    :error-messages="errors.collect('Warehouse')"
                    data-vv-name="Warehouse"
                    :label="$t('columns.warehouse') + '*'"
                    v-validate="'required'"
                  >
                  </v-select>
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                    v-model.number="form.order"
                    :label="$t('columns.order') + ' *'"
                    :error-messages="errors.collect('Order')"
                    v-validate="'required'"
                    data-vv-name="Order"
                  />
                </v-flex>

                <v-flex
                  v-if="isUpdate"
                  xs3
                >
                  <v-switch
                    v-model="form.is_active"
                    :label="$t('common.active')"
                    color="success"
                  />
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeDialog()"
                outline
                color="normal"
              >{{ $t('common.cancel') }}</v-btn>
              <v-btn
                type="submit"
                :loading="loading"
                style="height:auto" class="submit-btn-spacing"
                outline
                color="success"
              >
                {{ isUpdate ? $t('common.save') : $t('common.add') }}
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios'
import swal from 'sweetalert'

export default {
  props: ['addEditGlobalWebsiteModal', 'form', 'isUpdate', 'warehouses'],

  data() {
    return {
      loading: false
    }
  },

  methods: {
    closeDialog() {
      this.$validator.reset()
      this.$emit('close')
    },

    chooseImage() {
      this.$refs.globalWebsiteLogoRef.click()
    },

    imageSelected() {
      const imageFile = this.$refs.globalWebsiteLogoRef.files[0]
      if (imageFile.type.includes('image/')) {
        this.form.logo = imageFile
        this.form.logoUrl = URL.createObjectURL(imageFile)
        this.form.logo_updated = true
      } else {
        swal({
          title: this.$t('forceUpdate.imageMustBeImageError'),
          text: '',
          icon: 'error',
          timer: 1500,
          buttons: false
        })
      }
    },

    submitForm() {
      let token = localStorage.getItem('access_token')

      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true

          let formData = new FormData()
          formData.append('logo', this.form.logo)
          formData.append('order', this.form.order)
          formData.append('warehouse_id_fk', this.form.warehouse_id_fk)
          formData.append('global_website_group_id_fk', this.form.global_website_group_id_fk)
          formData.append('is_active', this.form.is_active)
          formData.append('logo_updated', this.form.logo_updated)
          formData.append('url', this.form.url)

          if (this.isUpdate) {
            formData.append('_method', 'put')
            Axios.post(`api/global-website/${this.form.global_website_id}`, formData, {
              headers: { Authorization: 'Bearer ' + token }
            })
              .then(() => {
                this.loading = false
                swal({
                  title: this.$t('common.updatedSuccessfully'),
                  text: '',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                })
                this.$emit('resetTable')
                this.closeDialog()
              })
              .catch((error) => {
                this.loading = false
                swal(this.$t('common.error'), error.response.data.message, 'error')
              })
          } else {
            Axios.post('api/global-website', formData, {
              headers: { Authorization: 'Bearer ' + token }
            })
              .then(() => {
                this.loading = false
                swal({
                  title: this.$t('common.addedSuccessfully'),
                  text: '',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                })
                this.$emit('resetTable')
                this.closeDialog()
              })
              .catch((error) => {
                this.loading = false
                swal(this.$t('common.error'), error.response.data.message, 'error')
              })
          }
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}

.image-upload-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.image-upload {
  border: 1px dashed #ccc;
  cursor: pointer;
  position: relative;
  background-position: center;
  background-size: cover;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/globalWebsite/addEditGlobalWebsite.vue